module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/7.side_image-44235d247dc1422c9e65cdc982158768.png";